import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { HelmetProvider } from 'react-helmet-async';
import NavigationBar from './components/common/Navbar';
import Footer from './components/common/Footer';
import ErrorBoundary from './components/common/ErrorBoundary';
import ScrollToTop from './components/common/ScrollToTop';

// Import pages
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import Manufacturing from './pages/Manufacturing';
import ThankYou from './pages/ThankYou';
import Brands from './pages/Brands';
import BrandPage from './pages/BrandPage';
import Quality from './pages/Quality';

// Import dynamic product detail page
import ProductDetail from './pages/Products/ProductDetail';

// Import global styles
import './styles/global.css';

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <Router>
          <ScrollToTop />
          <div className="d-flex flex-column min-vh-100">
            <NavigationBar />

            {/* Skip to main content link for accessibility */}
            <a href="#main-content" className="skip-link">
              Skip to main content
            </a>

            <main id="main-content" className="main-content flex-grow-1" tabIndex={-1}>
              <Container fluid className="px-0 py-4">
                <ErrorBoundary>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/products/:slug" element={<ProductDetail />} />
                    <Route path="/brands" element={<Brands />} />
                    <Route path="/brands/:brandId" element={<BrandPage />} />
                    <Route path="/quality" element={<Quality />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/manufacturing" element={<Manufacturing />} />
                    <Route path="/thank-you" element={<ThankYou />} />
                  </Routes>
                </ErrorBoundary>
              </Container>
            </main>

            <Footer />
          </div>
        </Router>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
